// Equality of metric values: relative tolerance with an absolute floor for values near 0.
// NaN, null, and undefined are equal to each other (SQLite stores NaN as NULL).
export const TOLERANCE = 1e-9;

export function isMissing(value) {
    return value === null || value === undefined || Number.isNaN(value);
}

export function isClose(actual, expected, tolerance = TOLERANCE) {
    if (isMissing(actual) || isMissing(expected)) return isMissing(actual) && isMissing(expected);
    return Math.abs(actual - expected) <= tolerance * Math.max(1, Math.abs(expected));
}
